<template>
  <div
    v-if="value.length == 11"
    class="noWrap"
  >
    {{ value | CpfFilter }}
  </div>
  <div
    v-else
    class="noWrap"
  >
    {{ value | CnpjFilter }}
  </div>
</template>

<script>
import CpfFilter from 'Support/filters/formatCpf';
import CnpjFilter from 'Support/filters/formatCnpj';

export default {
  name: 'DataTableCpfRow',
  filters: { CnpjFilter, CpfFilter },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>
